const CeleryIcon = require('@/assets/allergies/celery.png');
const CornIcon = require('@/assets/allergies/corn.png');
const CrabIcon = require('@/assets/allergies/crab.png');
const EggIcon = require('@/assets/allergies/egg.png');
const FishIcon = require('@/assets/allergies/fish.png');
const GlutenIcon = require('@/assets/allergies/gluten.png');
const LupinIcon = require('@/assets/allergies/lupin.png');
const MilkIcon = require('@/assets/allergies/milk.png');
const MolluscsIcon = require('@/assets/allergies/molluscs.png');
const MustardIcon = require('@/assets/allergies/mustard.png');
const NutsIcon = require('@/assets/allergies/nuts.png');
const SesameIcon = require('@/assets/allergies/sesame.png');
const ShellfishIcon = require('@/assets/allergies/shellfish.png');
const SoyaIcon = require('@/assets/allergies/soya.png');
const SulphitesIcon = require('@/assets/allergies/sulphites.png');

const Allergies = [
    'celery',
    'corn',
    'crab',
    'egg',
    'fish',
    'gluten',
    'lupin',
    'milk',
    'molluscs',
    'mustard',
    'nuts',
    'sesame',
    'shellfish',
    'soya',
    'sulphites'
]

const AllergyIconSource = [
        {Name : 'celery', Source : CeleryIcon },
        {Name : 'corn', Source : CornIcon },
        {Name : 'crab', Source : CrabIcon },
        {Name : 'egg', Source : EggIcon },
        {Name : 'fish', Source : FishIcon },
        {Name : 'gluten', Source : GlutenIcon },
        {Name : 'lupin', Source : LupinIcon },
        {Name : 'milk', Source : MilkIcon },
        {Name : 'molluscs', Source : MolluscsIcon },
        {Name : 'mustard', Source : MustardIcon },
        {Name : 'nuts', Source : NutsIcon },
        {Name : 'sesame', Source : SesameIcon },
        {Name : 'shellfish', Source : ShellfishIcon },
        {Name : 'soya', Source : SoyaIcon },
        {Name : 'sulphites', Source : SulphitesIcon },

    ];

function getAllergyIcon(allergy) {
    //console.log(allergy);
    let icon = AllergyIconSource.find(e => {
        //console.log('AllergyIconSource')
        if (e.Name === allergy) {
            return e;
        }
    });
    //console.log('getAllergyIcon: ');
    //console.log(icon);
    return icon;
};

function getAllergyIcons(allergies) {
    let array = [];
    for(let i = 0; i < allergies.length; i++) {
        let icon = getAllergyIcon(allergies[i]);
        array.push(icon);
    }
    //console.log('getAllergyIcons: ');
    //console.log(array);
    return array;
}


export default {
    CeleryIcon,
    CornIcon,
    CrabIcon,
    EggIcon,
    FishIcon,
    GlutenIcon,
    LupinIcon,
    MilkIcon,
    MolluscsIcon,
    MustardIcon,
    NutsIcon,
    SesameIcon,
    ShellfishIcon,
    SoyaIcon,
    SulphitesIcon,
    AllergyIconSource,
    Allergies,
    getAllergyIcons
}



